import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { CssBaseline, ThemeProvider } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import MethodNotRegisteredDialog from 'components/Dialogs/missing-method-dialog'
import { ValidateCodeDialog } from 'components/Dialogs/validate-code-dialog'
import ValidEmailDialog from 'components/Dialogs/validate-email-dialog'
import FullPageLoadingOverlay from 'components/FullOverlay'

import { LoadingProvider } from 'context/loading-context'
import { ModalProvider } from 'context/modal-context'

import 'utils/theme/styles.css'

import App from './App'
import i18n from './i18n'
import { setupAxiosInterceptors } from './services/axiosConfig'
import { queryClient } from './services/query-client'
import theme from './utils/theme'

import { QueryClientProvider } from '@tanstack/react-query'

import { UserProvider } from 'UserContext'

const root = ReactDOM.createRoot(document.getElementById('root'))

setupAxiosInterceptors()

root.render(
  <React.StrictMode>
    <LoadingProvider>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <UserProvider>
            <ThemeProvider theme={theme}>
              <ModalProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <BrowserRouter>
                    <App />
                    <CssBaseline />
                    <ValidateCodeDialog />
                    <ValidEmailDialog />
                    <MethodNotRegisteredDialog />
                    <FullPageLoadingOverlay />
                  </BrowserRouter>
                </LocalizationProvider>
              </ModalProvider>
              <ToastContainer position="top-right" />
            </ThemeProvider>
          </UserProvider>
        </QueryClientProvider>
      </I18nextProvider>
    </LoadingProvider>
  </React.StrictMode>
)
